import {
  BodyText,
  StyledCaseReportSectionTitle,
} from 'src/components/atomsLegacy';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  min-width: 0;
  margin-bottom: 12px;
`;

export const Title = styled(StyledCaseReportSectionTitle)`
  text-transform: uppercase;
  margin: 10px 0 0;
`;

export const Text = styled(BodyText)`
  margin-top: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0px;
`;

export const FieldButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 12px;
`;

export const Input = styled.input`
  background: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N0
      : props.theme.atlas.semantic.color.surface.default};
  border: 1px solid
    ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N400
        : props.theme.atlas.semantic.color.outline.default};
  border-radius: 4px;
  padding: 5px;
  width: 100%;
  margin-top: 4px;
  height: 32px;
`;
